module.exports = __webpack_public_path__ + "img/img_12@2x.052712dc.png";